import { f as r } from "./function-call.js";
import { a as e } from "./an-object.js";
import { i as a } from "./is-callable.js";
import { c as o } from "./classof-raw.js";
import { r as c } from "./regexp-exec.js";
var s = TypeError,
  t = function t(_t, i) {
    var p = _t.exec;
    if (a(p)) {
      var f = r(p, _t, i);
      return null !== f && e(f), f;
    }
    if ("RegExp" === o(_t)) return r(c, _t, i);
    throw s("RegExp#exec called on incompatible receiver");
  };
export { t as r };